import { apiHelper } from "../apiHelper/apiHelper";
import {
  getAdminsFailure,
  getAdminsRequest,
  getAdminsSuccess,
  assignBudgetFailure,
  assignBudgetRequest,
  assignBudgetSuccess,
} from "../slices/adminSlices";
import { toast } from "react-toastify";



export const handleGetAdminData = (adminId) => async (dispatch) => {
  // Remove token handling here, as it's managed in apiHelper
  const endPoint = `admin/getadmindata/${adminId}`;
  const method = "GET";
  const body = null; // Since this is a GET request, no body needed
  const state1 = getAdminsRequest;
  const state2 = getAdminsSuccess;
  const state3 = getAdminsFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  // Call the apiHelper to fetch data
  const success = await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );

  if (!success) {
    toast.error("Failed to fetch admin data.");
  }
};


// Fetch company data (company -> includes admin, suppliers, farmers, consultants)
export const handleGetCompanyData = (companyId) => async (dispatch) => {
  const endPoint = `company/${companyId}`;
  const method = "GET";
  const body = null;
  const state1 = getAdminsRequest;
  const state2 = getAdminsSuccess;
  const state3 = getAdminsFailure;
  const isFile = false;
  const isToast = false;
  const isToken = true;

  const result = await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );

  if (!result) {
    toast.error("Failed to fetch company data.");
  }
  // If backend returned company under result.data.company, map it to the shape the UI expects
  // so components can continue reading adminList.admin.*
  if (result && result.data && result.data.company) {
    const company = result.data.company;
    const mappedPayload = {
      admin: company,
      // keep original raw response for reference if needed
      data: { company },
      message: result.message || "Success",
      statusCode: result.statusCode || 200,
    };
    // overwrite with mapped payload so UI can read adminList.admin
    dispatch(state2(mappedPayload));
  }
};

// create user
export const handleAssignBudget = async (formData, adminId, dispatch) => {
  const endPoint = `admin/assign-budget/${adminId}`;
  const method = "POST";
  const state1 = assignBudgetRequest;
  const state2 = assignBudgetSuccess;
  const state3 = assignBudgetFailure;
  const isToast = true;
  const isFile = false;
  const isToken = true;
  const body = formData;
  return await apiHelper(
    endPoint,
    method,
    body,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};